export enum ToolPurpose {
  none,
  replace,
  add,
  remove,
}

export enum Tool {
  none,
  rectangle,
  circle,
}

export enum ToolState {
  none,
  chooseAnchorStart,
  chooseAnchorEnd,
  finished,
}
